import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Grid, TextField } from "@material-ui/core";
import Form from "./Form";
import { getAppSettings, updateAppSettings } from "../../actions/userActions";
import AttachFileIcon from "@material-ui/icons/AttachFile";

class UpdateAppSettingsForm extends Component {
  state = {
    name: "",
    address: "",
    color: "",
    logo: "",
  };

  componentDidMount() {
    this.props.getAppSettings().then((response) => {
      this.setState({ ...response });
    });
  }

  updateAppSettings = (e) => {
    e.preventDefault();
    this.props.updateAppSettings(this.state);
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleFileUploadChange = (e) => {
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);

    reader.onload = function () {
      this.setState({ logo: reader.result });
    }.bind(this);
  };

  render() {
    return (
      <Form
        onSubmit={this.updateAppSettings}
        submitText="Wijzigen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="name"
              name="name"
              label="App naam*"
              value={this.state.name}
              onChange={this.handleChange}
              type="text"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id="address"
              name="address"
              label="Adres*"
              value={this.state.address}
              onChange={this.handleChange}
              type="text"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <label htmlFor="color">Kleur</label> <br />
            <br />
            <input
              id="color"
              name="color"
              type="color"
              value={this.state.color}
              onChange={this.handleChange}
            ></input>
          </Grid>
          <Grid item xs={12} sm={12}>
            {this.state.logo && (
              <img
                src={this.state.logo}
                style={{ width: "200px", margin: "0 auto" }}
              />
            )}{" "}
            <br />
            <input
              id="logo"
              type="file"
              accept="image/png"
              onChange={this.handleFileUploadChange}
              style={{ display: "none" }}
            />
            <label htmlFor="logo">
              <Button variant="contained" component="span">
                <AttachFileIcon />
                Upload app logo
              </Button>
            </label>
          </Grid>
        </Grid>
      </Form>
    );
  }
}

UpdateAppSettingsForm.propTypes = {
  getAppSettings: PropTypes.func.isRequired,
  updateAppSettings: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.user.updateAppSettings.successMessage,
  errorMessage: state.user.updateAppSettings.errorMessage,
  isFetching: state.user.updateAppSettings.isFetching,
});

export default connect(mapStateToProps, { getAppSettings, updateAppSettings })(
  UpdateAppSettingsForm,
);



// WEBPACK FOOTER //
// ./src/components/forms/UpdateAppSettingsForm.js